import clsx from "clsx";

import GenericProfilePic from "assets/images/generic-profile-pic.png";
import { MessageSourceType } from "utils/enum";

import styles from "./styles.module.scss";
import { ChatMessageHeaderProps } from "./types";

export default function ChatMessageHeader({
	timestamp,
	messageSource,
	profilePic,
	messageSender
}: ChatMessageHeaderProps) {
	const isUserMessage = messageSource === MessageSourceType.PARTNER;
	const getSenderName = () => {
		if (isUserMessage) return "(Você)";
		if (messageSource === MessageSourceType.CLIENT)
			return messageSender ?? "Cliente";
		return "Cliente";
	};
	return (
		<div
			className={clsx([styles.container], {
				[styles.userContainer]: isUserMessage,
				[styles.franchiseContainer]: !isUserMessage
			})}
		>
			<div className={styles.avatar}>
				<img src={profilePic || GenericProfilePic} alt="" />
			</div>
			<div>
				<div className={styles.userName}>
					<h3 className="heading_sm">{getSenderName()}</h3>
				</div>
				<p
					className={clsx(["body text-neutral-500"], {
						"text-right": isUserMessage
					})}
				>
					{timestamp}
				</p>
			</div>
		</div>
	);
}
